<template>
  <header class="site-header">
    <div class="header-container">
      <!-- Logo -->
      <div class="logo">
        <router-link to="/">
          <img src="../assets/images/logo.png" alt="长江" />
        </router-link>
      </div>

      <!-- Mobile Menu Button -->
      <button class="mobile-menu-btn" @click="toggleMobileMenu" :class="{ active: mobileMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <!-- Navigation Menu (Desktop) -->
      <nav class="nav-menu desktop-menu">
        <ul>
          <li>
            <router-link to="/" :class="{ active: $route.path === '/' }">
              首页
            </router-link>
          </li>
          <li>
            <router-link to="/products" :class="{ active: $route.path === '/products' }">
              产品中心
            </router-link>
          </li>
          <li>
            <router-link to="/about" :class="{ active: $route.path === '/about' }">
              品牌介绍
            </router-link>
          </li>
          <li>
            <router-link to="/blog" :class="{ active: $route.path === '/blog' }">
              媒体中心
            </router-link>
          </li>
        </ul>
      </nav>

      <!-- Right Actions (Desktop) -->
      <div class="header-actions desktop-actions">
        <!-- Buy Button -->
        <a href="https://l.tuhu.cn/6Va8dc" target="_blank" class="buy-btn">
          前往购买
        </a>
      </div>
    </div>

    <!-- Mobile Navigation Menu -->
    <transition name="slide-fade">
      <div v-if="mobileMenuOpen" class="mobile-nav-menu">
        <nav>
          <ul>
            <li>
              <router-link to="/" :class="{ active: $route.path === '/' }" @click.native="closeMobileMenu">
                首页
              </router-link>
            </li>
            <li>
              <router-link to="/products" :class="{ active: $route.path === '/products' }" @click.native="closeMobileMenu">
                产品中心
              </router-link>
            </li>
            <li>
              <router-link to="/about" :class="{ active: $route.path === '/about' }" @click.native="closeMobileMenu">
                品牌介绍
              </router-link>
            </li>
            <li>
              <router-link to="/blog" :class="{ active: $route.path === '/blog' }" @click.native="closeMobileMenu">
                媒体中心
              </router-link>
            </li>
          </ul>
          <div class="mobile-buy-btn-wrapper">
            <a href="https://wx.tuhu.cn/vue/wx/pages" target="_blank" class="buy-btn" @click="closeMobileMenu">
              前往购买
            </a>
          </div>
        </nav>
      </div>
    </transition>

    <!-- Mobile Menu Overlay -->
    <transition name="fade">
      <div v-if="mobileMenuOpen" class="mobile-menu-overlay" @click="closeMobileMenu"></div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      mobileMenuOpen: false
    };
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      // 防止背景滚动
      if (this.mobileMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.style.overflow = '';
    }
  },
  watch: {
    // 路由变化时关闭菜单
    '$route'() {
      this.closeMobileMenu();
    }
  },
  beforeDestroy() {
    // 组件销毁时恢复滚动
    document.body.style.overflow = '';
  }
};
</script>

<style lang="scss" scoped>
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  .header-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    a {
      display: flex;
      align-items: center;
    }

    img {
      height: 50px;
      width: auto;
    }
  }

  .nav-menu {
    ul {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;
      gap: 50px;

      li {
        position: relative;

        a {
          color: #333;
          font-size: 16px;
          font-weight: 500;
          padding: 10px 0;
          position: relative;
          transition: color 0.3s ease;

          &:hover,
          &.active {
            color: #ed1c24;
          }

          &.active::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 3px;
            background: #ed1c24;
            border-radius: 2px;
          }
        }
      }
    }
  }

  .header-actions {
    display: flex;
    align-items: center;

    .buy-btn {
      padding: 10px 24px;
      background: linear-gradient(135deg, #ed1c24 0%, #c91118 100%);
      color: #fff;
      border-radius: 25px;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
      transition: all 0.3s ease;
      white-space: nowrap;

      &:hover {
        background: linear-gradient(135deg, #c91118 0%, #a00d13 100%);
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(237, 28, 36, 0.3);
      }
    }
  }
}

/* Mobile Menu Button */
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;

  span {
    display: block;
    width: 100%;
    height: 3px;
    background: #333;
    border-radius: 2px;
    transition: all 0.3s ease;
  }

  &.active {
    span:nth-child(1) {
      transform: translateY(10.5px) rotate(45deg);
    }

    span:nth-child(2) {
      opacity: 0;
    }

    span:nth-child(3) {
      transform: translateY(-10.5px) rotate(-45deg);
    }
  }
}

/* Mobile Navigation Menu */
.mobile-nav-menu {
  display: none;
  position: fixed;
  top: 60px;
  right: 0;
  width: 280px;
  max-width: 80%;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  z-index: 999;
  height: calc(100vh - 60px);
  overflow-y: auto;

  nav {
    padding: 20px 0;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        border-bottom: 1px solid #f0f0f0;

        a {
          display: block;
          padding: 16px 24px;
          color: #333;
          font-size: 16px;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.3s ease;

          &:hover,
          &.active {
            background: #f8f9fa;
            color: #ed1c24;
            padding-left: 30px;
          }

          &.active {
            border-left: 4px solid #ed1c24;
          }
        }
      }
    }

    .mobile-buy-btn-wrapper {
      padding: 20px 24px;

      .buy-btn {
        display: block;
        width: 100%;
        text-align: center;
        padding: 12px 24px;
        background: linear-gradient(135deg, #ed1c24 0%, #c91118 100%);
        color: #fff;
        border-radius: 25px;
        font-size: 14px;
        font-weight: 500;
        text-decoration: none;
        transition: all 0.3s ease;

        &:hover {
          background: linear-gradient(135deg, #c91118 0%, #a00d13 100%);
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(237, 28, 36, 0.3);
        }
      }
    }
  }
}

/* Mobile Menu Overlay */
.mobile-menu-overlay {
  display: none;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

/* Transitions */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// Mobile responsive
@media (max-width: 768px) {
  .site-header {
    .header-container {
      padding: 0 20px;
      height: 60px;
    }

    .logo img {
      height: 35px;
    }

    .mobile-menu-btn {
      display: flex;
    }

    .desktop-menu {
      display: none;
    }

    .desktop-actions {
      display: none;
    }
  }

  .mobile-nav-menu {
    display: block;
  }

  .mobile-menu-overlay {
    display: block;
  }
}
</style>
